import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./BankIntegrationPage.scss";
import fcBankIntegration from "../../assets/images/banner-bank-integration.png";
import Copyright from "../../components/Copyright/Copyright";

const BankIntegrationPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={fcBankIntegration} alt="Bank Integration" />
          </div>
        </div>
      </section>

      {/* Bank Integration Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Bank integration</h2>
              <p>
                CashManager provides comprehensive bank integration capabilities that streamline
                your financial operations and ensure secure, automated payment processing.
              </p>

              <div className="feature-methods three-columns">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>Host-2-Host integration</h3>
                    <p>Direct, secure connection to your bank's systems for real-time payment processing and statement retrieval.</p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Gateway services</h3>
                    <p>Seamless integration with payment gateways for online transactions and e-commerce solutions.</p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>File-based processing</h3>
                    <p>Support for various file formats (XML, CSV, MT940) for batch processing and statement imports.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>

              <div className="features-list">
                <div className="feature-item">
                  <h3>Real-time payment processing</h3>
                  <p>Create payments instantly from invoices or supplier data with immediate confirmation and status updates.</p>
                </div>

                <div className="feature-item">
                  <h3>Automated statement processing</h3>
                  <p>Automatically import and reconcile bank statements with your accounting records. <Link to="/automatic-bank-reconciliation">Learn more...</Link></p>

                </div>

                <div className="feature-item">
                  <h3>Multi-bank support</h3>
                  <p>Connect to multiple banks and financial institutions from a single platform.</p>
                </div>

                <div className="feature-item">
                  <h3>Secure authentication</h3>
                  <p>Bank-grade security with multi-factor authentication and encryption protocols.</p>
                </div>

                <div className="feature-item">
                  <h3>Error handling & monitoring</h3>
                  <p>Comprehensive error handling with detailed logging and monitoring capabilities.</p>
                </div>

                <div className="feature-item">
                  <h3>Save on bank charges</h3>
                  <p>Automatically consolidate payments to the same bank account to save on banking fees.</p>
                </div>

                {/* <div className="feature-item">
                  <h3>Compliance & reporting</h3>
                  <p>Full compliance with financial regulations and comprehensive audit trails.</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Supported Banks Section */}
      <section className="supported-section">
        <div className="container">
          <div className="section-header">
            <h2>Supported banks & services</h2>
            <p>Below is just a short list of banks and services that we support. Our bank integration solution is flexible and can be customized to support any bank and service provider. <Link to="/contact">Contact us</Link> to discuss your specific banking integration needs.</p>
          </div>

          <div className="items-grid">
            <div className="item">
              <h3>Latvian and Baltic banks</h3>
              <ul>
                <li>Citadele</li>
                <li>Luminor</li>
                <li>SEB</li>
                <li>Swedbank Baltics</li>
                <li>Other banks  - <Link to="/contact">Contact us</Link> to find out if your bank is supported</li>
              </ul>
            </div>

            <div className="item">
              <h3>International banks</h3>
              <ul>
                <li>Banco Santander</li>
                <li>BNC Paribas</li>
                <li>HSBC</li>
                <li>Standard Bank</li>
                <li>And many more  - <Link to="/contact">Contact us</Link> to find out if your bank is supported</li>
              </ul>
            </div>

            <div className="item">
              <h3>File formats</h3>
              <ul>
                <li>ISO 20022 (PAIN, CAMT)</li>
                <li>MT940 (SWIFT)</li>
                <li>FiDAViSta / XML</li>
                <li>CSV</li>
                <li>Other formats  - <Link to="/contact">Contact us</Link> to find out more</li>
              </ul>
            </div>

            <div className="item">
              <h3>Direct integrations</h3>
              <ul>
                <li>Citadele Gateway</li>
                <li>HSBC Host-2-Host</li>
                <li>SEB Baltic Gateway</li>
                <li>Swedbank Gateway</li>
                <li>Other - <Link to="/contact">Contact us</Link> to find out more</li>
              </ul>
            </div>

            <div className="item">
              <h3>Payment gateways</h3>
              <ul>
                <li>PayPal</li>
                {/* <li>Revolut</li> */}
                {/* <li>Stripe</li> */}
                <li>Wise</li>
                <li>Custom gateways</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Implementation process</h2>
            <p>Get started with bank integration in just a few simple steps</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Initial consultation</h3>
                <p>We assess your current banking setup and integration requirements.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Technical setup</h3>
                <p>Configure secure connections and establish API endpoints.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Testing & validation</h3>
                <p>Comprehensive testing in a secure environment to ensure reliability.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Go Live & support</h3>
                <p>Deploy to production with ongoing support and monitoring.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to integrate with your bank?</h2>
            <p>Contact our team to discuss your specific banking integration needs and get started today.</p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default BankIntegrationPage;
